import { render, staticRenderFns } from "./PedidoCompraForm.vue?vue&type=template&id=d4c3725e&"
import script from "./PedidoCompraForm.vue?vue&type=script&lang=js&"
export * from "./PedidoCompraForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports